// extracted by mini-css-extract-plugin
module.exports = {"container":"new-alert_container__1AuPP","box":"new-alert_box__DvUUc","box__text":"new-alert_box__text__1Q30J","box__icon-plus":"new-alert_box__icon-plus__1FP5E"};